<template>
  <div class="trusted-partners-container">
    <div class="title-container">
      <h1 class="main-title">{{ title }}</h1>
    </div>
    <div class="partner-logos-container">
      <div
        v-for="(partner, index) in partners"
        :key="index"
        class="partner-logo"
      >
        <a :href="partner.website" target="_blank" rel="noopener noreferrer">
          <img
            :src="partner.logo"
            :alt="partner.name"
            class="logo-image"
            :style="{
              maxWidth: partner.customMaxWidth || '',
              maxHeight: partner.customMaxHeight || '',
            }"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrustedPartners",
  props: {
    title: {
      type: String,
      default: "Trusted by Schools and Educators worldwide",
    },
  },
  data() {
    return {
      partners: [
        {
          name: "Breck School",
          logo: require("@/assets/t_brecks.png"),
          website: "https://www.breckschool.org/",
        },
        {
          name: "Nagoya International School",
          logo: require("@/assets/t_nagoya_international_school.png"),
          website: "https://www.nis.ac.jp/",
        },
        {
          name: "Japan National Tourism Organization",
          logo: require("@/assets/t_japan_national_travel.png"),
          website: "https://www.japan.travel/en/us/",
          customMaxWidth: "340px",
          customMaxHeight: "185px",
        },
        {
          name: "JAAGO Foundation",
          logo: require("@/assets/t_JAAGO_Foundation.jpeg"),
          website: "https://jaago.com.bd/",
        },
        {
          name: "Baja Adventures",
          logo: require("@/assets/t_baja_adventures.png"),
          website: "https://www.bajaadventures.com/",
          customMaxWidth: "300px",
          customMaxHeight: "165px",
        },
      ],
    };
  },
};
</script>

<style scoped>
.trusted-partners-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8rem;
}

.title-container {
  margin-bottom: 3rem;
  text-align: center;
}

.main-title {
  font-size: 3rem;
  color: #000;
}

.partner-logos-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  width: 80%;
  max-width: 1200px;
}

.partner-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
}

.partner-logo:hover {
  transform: scale(1.05);
}

.logo-image {
  max-width: 180px;
  max-height: 100px;
  object-fit: contain;
}

/* Responsive design */
@media (max-width: 768px) {
  .partner-logos-container {
    gap: 2rem;
    width: 90%;
  }

  .logo-image {
    max-width: 120px;
    max-height: 80px;
  }

  .main-title {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .partner-logos-container {
    gap: 1.5rem;
    width: 95%;
  }

  .logo-image {
    max-width: 100px;
    max-height: 60px;
  }
}
</style>
